export default __webpack_public_path__ + "static/media/pay.006c8f97.png";